import { useTranslation } from "react-i18next";
import PageHeader from "../../components/common/pageheader/PageHeader";

const AnalyticsPage = () => {
  const { t } = useTranslation();
  return (
    <div>
      <PageHeader title={t("stubs.analyticsTitle")} />
      <p>{t("stubs.analyticsPlaceholder")}</p>
    </div>
  );
};

export default AnalyticsPage;
